import HomeIcon from '../../assets/Icons/navigation-icon/Home';
import LogoutIcon from '../../assets/Icons/navigation-icon/LogoutIcon';

export const sideBarContentAdmin = [
  {
    pageName: 'Dashboard',
    navMenuName: 'Dashboard',
    sideNavIcon: <HomeIcon />,
    activeSideNavIcon: <HomeIcon />,
    id: 1,
    pageRoute: '/',
    page: '/',
  },
];


export const sideBarBottomContent = [
  {
    pageName: 'Sign out',
    navMenuName: 'Sign out',
    sideNavIcon: <LogoutIcon color='#cccccc' />,
    activeSideNavIcon: <LogoutIcon />,
    id: 1,
    pageRoute: '/signout',
    page: '/signout',
  },

];